// extracted by mini-css-extract-plugin
export var modal = "_5o-0";